module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAO5JREFUOBHtk8sNwjAMhpuUM5mEGWAHRmCJqlJFuVS9wAaMwA4wUnrvw0YYGVshLaK3RoriR/zlj5UkyTLm7oCZekBd1857fzDGrKm27/vGOXfNssxTbEXG2BWhADrD/CiBOPoXCipwTBEqlVCE8Rugr8BjFWHxt2FlUp5M+VCc8nJVYLnhV//5Koqi2LRtu0cI9G8LcyeBoPgO8xHLY12aprd5FXN1eZ6XXdcdeQxta+2pqqoylqe62RQrMPSwoVP5GorzPdxW7xi/Jv4i/rwQinFeGLMV+PXf319TAkLKZVyBJUj6/7qR5C7+9A4MCrR+uIVtGSQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_ValignMiddle_disabled.png
// module id = 320
// module chunks = 0